export const updates = [
    {
        id: '2020-07-18',
        date: '2020-07-18 17:30 GMT',
        label: 'Update - 18 July 2020',
    },
	// {
    //     id: '2020-02-14',
    //     date: '2020-02-214 17:30 GMT',
    //     label: 'Update - 14 February 2020',
    // },
    {
        id: '2019-04-04',
        date: '2019-04-04 12:30 GMT',
        label: 'Update - 4 April 2019',
    },
    {
        id: '2018-11-20',
        date: '2018-11-20 15:30 GMT',
        label: 'Update - 20 November 2018',
    },
    {
        id: '2018-07-19',
        date: '2018-07-19 13:30 GMT',
        label: 'Update - 19 July 2018',
    },
    {
        id: '2018-07-04',
        date: '2018-07-04 12:00 GMT',
        label: 'Update - 4 July 2018',
    },
    {
        id: '2018-05-31',
        date: '2018-05-31 15:00 GMT',
        label: 'Update - 31 May 2018',
    },
    {
        id: '2018-05-23',
        date: '2018-05-23 15:30 GMT',
        label: 'Update - 23 May 2018',
    },
    {
        id: '2018-04-24',
        date: '2018-03-04 14:30 GMT',
        label: 'Update - 24 April 2018',
    },
    {
        id: '2018-04-12',
        date: '2018-04-12 15:00 GMT',
        label: 'Update - 12 April 2018',
    },
    {
        id: '2018-03-04',
        date: '2018-03-04 12:30 GMT',
        label: 'Update - 4 March 2018',
    },
];



// WEBPACK FOOTER //
// ./src/portal/states/company/whats-new/updates.js